import { ADMIN_MAILS } from './index';
import { Action } from '../action';

export class AdminMailsInitAction implements Action {
	readonly type = ADMIN_MAILS.INIT;
	constructor(
		public payload?: null,
		public correlationId?: number
	) {}
}

export class AdminMailsDestroyAction implements Action {
	readonly type = ADMIN_MAILS.DESTROY;
	constructor(
		public payload?: null,
		public correlationId?: number
	) {}
}
